module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch01"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter One")])]), _vm._v(" "), _c('p', {
    staticClass: "centerImage0"
  }, [_c('img', {
    staticClass: "epubimage",
    attrs: {
      "alt": "image",
      "src": "Images/ch1.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "chapterBody"
  }, [_c('p', {
    staticClass: "chapterDateline",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("The Mayo Clinic, Rochester, Minnesota"), _c('br'), _vm._v(" July, Four Years Earlier")])]), _vm._v(" "), _c('p', {
    staticClass: "chapterOpenerText",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("On a sweltering Friday afternoon, the day before we were to officially begin our residency, we gathered in a small classroom on the fourteenth floor of the Mayo Building for our orientation meeting. Crammed into this room were fifteen incredibly bright first-year orthopedic surgery residents—and me, a twenty-nine-year-old ex-cabdriver and ex-construction worker long on dreams but short on credentials.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("We were introduced one by one. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Phi Beta")]), _vm._v(" this, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Alpha Omega")]), _vm._v(" that. The Mayo Clinic was the most prestigious medical center in the world, and I began to wonder what I was doing there. I was the redheaded stepchild, the dullest scalpel in the drawer.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("All the other residents had done several rotations in orthopedics when they were in medical school. Most of them had spent their nights writing papers or doing orthopedic research. When I was in medical school I had spent my nights working on a truck dock. I had done no research, had written no papers, and had done only one rotation in ortho. I had no exposure to the world of adult reconstructive surgery that was such a big part of orthopedics at the Mayo Clinic.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("After the introductions, a towering man with thick lips and wavy gray hair lumbered up to the podium. He introduced himself as Dr. John Harding, the chairman of the department. He welcomed us and then gave a brief history of orthopedic surgery at Mayo, going all the way back to Drs. Will and Charlie Mayo, who had founded the Clinic in the 1890s. He said we were lucky to be starting in orthopedics now. “Twenty years ago there were no joint replacements. There was no arthroscopy. The things we can do for our patients now could scarcely have been imagined back when I started in orthopedics.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("When Dr. Harding finished, a short, wrinkle-faced man with thick glasses approached the microphone. He waited until the room was quiet before he introduced himself. “I am Dr. Benjamin Burke,” he said, “the director of the residency program.” After a few words of welcome, he reminded us of the sacredness of our profession, and told us we had a long, but gratifying, road ahead of us. “You will spend four years here,” he said. “Two years as a junior resident, and two as a senior resident. If you work hard enough, if you’re skilled enough, we might consider you for chief resident in your final year.” He concluded by saying, “This is the Mayo Clinic. Our patients expect a lot from us, and we are going to expect a lot from you.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Finally, Viola Hopkins, Dr. Burke’s secretary, passed out our first-quarter assignments.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“There are two Mayo Clinic hospitals,” Vi said. “You will spend time at both hospitals, but for the first quarter, twelve of you have been assigned to St. Mary’s Hospital. The remaining four will be at Rochester Methodist Hospital.” She said she looked forward to meeting each of us personally, and wished us a “happy and blessed four years here at Mayo.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I tore open my packet. There were four names under the heading Rochester Methodist Hospital:")]), _vm._v(" "), _c('div', {
    staticClass: "extract"
  }, [_c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "35%"
    }
  }, [_vm._v("Chapin, William T.")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "35%"
    }
  }, [_vm._v("Collins, Michael J.")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "35%"
    }
  }, [_vm._v("Manning, John F.")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "35%"
    }
  }, [_vm._v("Wales, Frank")])]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("As we filed out of the classroom someone tapped me on the shoulder.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Mike Collins?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Yeah,” I said, turning around.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("A stocky, freckle-faced man with an unruly mass of red hair held out his hand. “Bill Chapin,” he said. “I guess we’re going to be inmates together.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("As we shook hands Bill said, “Have you met these two characters yet?” He gestured behind him.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("A friendly-looking guy with a bushy brown mustache and a string tie smiled and took my hand in both of his. “Wales,” he said. “Frank Wales. It’s a gol-dern pleasure to meet you.” Frank, as I was to learn, was a Wyoming farmboy with a big smile and a bigger heart. I never could figure out how much of his country-boy shtick was put on and how much was genuine.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“And I’m Jack Manning,” said a tall, athletic-looking man with round glasses and a receding hairline. I shook hands with Jack, too, who then asked me where I was from.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Chicago,” I said. “The West Side. How about you?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Corn country. Des Moines, Iowa.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I turned back to Frank Wales. “Frank, where are you from?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I’m from God’s country—”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You’re from Chicago, too?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Chicago? Why, son, I’m from Wyoming, Wind River Country. Home of elk and bison and wild mustang and mountain peaks stretching as far and as high as the eye can see. I don’t reckon you have anything like that in Chicago.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I said no, but we had some pretty big rats and cockroaches.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("After the others left I went back to the residents’ lounge and looked through the rest of my packet. I knew that each staff (or “attending”) surgeon at Mayo had his own list of patients: his service. A senior resident and a junior resident were assigned to each surgeon. I was dismayed to learn I would be the junior resident with Dr. Harding.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Oh, great, I thought. Just what I need, to have the chairman of the department find out what a dope he has hired. I imagined him grilling me the next day.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“How much research have you done, Dr. Collins?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Research? Well, I haven’t actually—”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“What about papers, then? Have you written anything?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Papers? Have I written papers? Well, not exactly. That is, ahem, not a lot. Well, maybe a little here and there, but nothing all that important. Of course I’ve been meaning to write them. Lots of them, in fact. I have some ideas, but I’ve been—” At that point I would let him know that my people would be getting back to his people on this. Soon.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Fortunately, Dr. Harding, or Big John, as the residents called him, took very little notice of me the next morning. After a perfunctory handshake, he directed his attention to the senior resident, Art Hestry. Art led us up to the ortho floor to make rounds on our patients. At Mayo, rounds are made twice a day. The attending surgeon accompanies his residents on rounds every morning except Sunday. The residents make rounds by themselves every afternoon plus Sunday morning.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("As we stood outside the first patient’s room, Art gave Dr. Harding a brief summary: “TKA, day 2. Hemovac out. Up today. Doing well.” This apparently meant something to Dr. Harding, who nodded and strode into the room. I shuffled after them wondering what the hell a TKA was.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("By staying in the background and keeping my mouth shut, I managed to make it through rounds without making my ignorance too obvious. But I was a sober, frightened young man when we finished rounds that morning. I had a lot of catching up to do.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("To make matters worse, there was the matter of the Saturday Morning Conference. Dr. Burke had warned us that all residents were required to attend this conference. I made my way to the hospital auditorium, where the conference was just beginning. One of the senior residents was presenting cases. I was in awe of his self-assurance and his command of orthopedic jargon.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“This is a fifty-two-year-old farmer, status-post right medial meniscectomy thirty years ago. He presents with a ten-year history of progressive DJD of the medial compartment. Dr. Coventry did a closing-wedge UTO last Wednesday.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I sat there in a daze, certain I was the most ignorant orthopedic resident in the history of the Mayo Clinic. I feverishly scribbled notes to myself: “UTO—??” and “Check X-rays on John Svendsen.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I was familiar with this type of conference from medical school. Cases are presented, then some unfortunate junior resident is asked a series of complex questions that he stammers through and always gets wrong. The senior resident or attending then gives the correct answer. Embarrassing the junior resident is considered a good thing. It is supposed to encourage him to study harder.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("But I was another story. Although I had been an excellent student in medical school, I had very little exposure to orthopedics. After hearing the impressive qualifications of my fellow residents, I began to think my problems went beyond mere inexperience. Compared to the others, I felt orthopedically anencephalic. I felt brain dead with the plug pulled. I felt so ignorant that had anyone called on me even my questioner would have been embarrassed. The entire department would shudder if they discovered this moron was one of them.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("At one point, Jack Manning, who was sitting behind me, leaned forward and asked how many UTOs I had scrubbed on. I pretended not to hear him. He might as well have asked how many UFOs I had flown on. At least I knew what a UFO was.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I don’t think it is possible for a person to shrink down any farther in his seat than I did that morning. By the end of the conference my head was below the seat back. As we were leaving Jack said it looked like I was melting. But at least I hadn’t been called on. My secret was safe for another week.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Even though the conference was over, I slunk out of the auditorium with my head down, still afraid someone might call me back and ask me under what circumstances would a hemi-arthroplasty be preferable to a total shoulder replacement? I would have thrown myself on the floor and asked them to shoot me and put me out of my misery.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("And misery it was. In less than twenty-four hours I had gone from the euphoria of beginning my career as an orthopedic resident at the Mayo Clinic to the feeling I was a counterfeit, an impostor who had infiltrated this society of brilliant surgeons. Once my ignorance was discovered I would be told to report immediately to the director of the residency program. I would be ushered into a dimly lit room lined with cherrywood bookshelves crammed with faded, leather-bound medical treatises from the 1700s. A somber-looking Dr. Burke would emerge from the shadows and tell me a mistake had been made, a terrible mistake. He would then hand me an ornately carved wooden box.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Go ahead,” he would say. “Open it.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I would lift the lid and find a twelve-inch, pearl-handled dagger, its blade glinting wickedly, resting on a tiny satin pillow.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("For the good of the residency program, for the good of the Mayo Clinic, for the good of every orthopedic surgeon who had ever picked up a scalpel, I would be urged to “do the right thing.” Dr. Burke couldn’t promise anything, of course, but if I “played ball,” if I was “a team player,” there was a chance my body would be given “first table” in the cadaver lab.")]), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak",
    staticStyle: {
      "text-indent": "0%"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("I went back to the doctors’ lounge and began copying the list of patients on Dr. Harding’s service. I planned to go back and review the chart on every patient. I had just finished copying the list when Art Hestry came in.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Mike,” he said, clapping me on the back. “I’m going up to the Twin Cities for the weekend. I need you to cover for me. I’ll do rounds this afternoon before I leave, but you’ll have to make rounds tomorrow.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He must have seen the look of horror on my face. “Don’t worry. If you have any problems, just call one of the senior residents, they’ll help you.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He laughed, handed me his beeper, said, “"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Heck")]), _vm._v(" of a deal!” and sailed out the door.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I stood there for several seconds, staring at this horrible thing, this beeper that rested in my still-outstretched hand. Gingerly, as if I were holding a vial of nitroglycerine, I clipped it to my belt. I was terrified that at any moment it might go off and a frantic nurse would scream, “Doctor, come quickly! Mr. Arnold’s TQF is trans-debilifying on his acute dorsi! His TKA is UTO’d! For God’s sake, hurry!”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I spent the rest of the day reviewing charts, slowly gleaning bits of information, jotting down on my ever-present index cards things like “TKA=\"Total\" Knee Arthroplasty,” “ORIF=\"Open\" Reduction Internal Fixation,” “UTO=\"Upper\" Tibial Osteotomy.” Some things, however, defied my best efforts to decipher them. “Patient is TTWB,” I read. Too tired with bending? Three times without bleeding? Terribly thirsty without beer? How in the hell did I know? Of course I could have asked the nurses, but they would have thrown me out the door for practicing medicine without a brain.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("At six o’clock I pulled into the driveway of our small frame house on the outskirts of Rochester. My wife, Patti, met me at the back door. Patti and I were both Chicago kids, West Side Irish, born at St. Ann’s Hospital at Lavergne and Thomas. Over her parents’ strenuous objections, Patti had married me in the summer before my junior year in medical school.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“So,” she said, throwing her arms around my neck, “how was your first day as an orthopedic surgeon?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I cringed. I realized that only by the farthest stretch of the imagination could I be considered an orthopedic surgeon. There were medical students who knew more orthopedics than I did. I kissed Patti and mumbled that my first day was “okay.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Then why the sad face? What did you do—operate on the wrong leg or something?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Aw, I don’t know, hon. I feel so dumb, so out of it. I don’t know the first thing about orthopedics.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Patti rubbed the back of her hand against my cheek. “That’s why they have residencies.”")]), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak",
    staticStyle: {
      "text-indent": "0%"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("One of the third-year ortho residents, John Stevenson, was giving a party that night. He had been thoughtful enough to invite the first-year guys. Patti and I left our twelve-month-old daughter, Eileen, with a babysitter. At eight o’clock we rang the doorbell of the Stevensons’ apartment.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Come on in,” said the guy who answered the door. “John’s in the kitchen.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The place was packed. It took me five minutes to find John. I handed him a six-pack of Olympia. He thanked me but said he hoped he wouldn’t need it. There was a keg in the kitchen.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Patti and I stumbled around, listening to snippets of conversation about things called IM rods and Putti-Platts and ACLs. God, how I longed to find someone who could talk about the Vikings or the North Stars. At least I could speak the language.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("We passed one of the residents on the hand service. He was talking about an operation they had done on a woman who had cut off her thumb in a lawn-mower accident. He said they removed her big toe and sewed it on her hand. I looked around. No one was laughing. The guy was serious.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("In the kitchen I finally found Bill, Frank, and Jack. They lifted their glasses in greeting and we introduced our wives.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Alice Chapin, a strikingly beautiful woman, was a redhead, like Bill. I learned later that she had given up a promising career in public relations to move to Rochester. She had just gotten a job at the Rochester Public Library.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Jack Manning’s wife, Sue, had warm hazel eyes and short brown hair. She was even more athletic looking than her husband. They had married right out of college. Jack told us they were expecting their first child in March.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“March?” Bill said, counting the months on his fingers. “When did Sue get pregnant, last night?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The biggest surprise was Linda Wales, Frank’s wife. Linda was an architect. In her crisp blouse and tight skirt, she was as sophisticated and polished as Frank was simple and rough-hewn. They had married when Frank was in medical school and Linda was getting her graduate degree.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("John Stevenson, passing by, noticed I was drinking a Coke.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Don’t you want a beer, Mike?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Nah. I’m on call.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“On your first night? Junior residents only take call in-house. You can’t be on call.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Art Hestry went up to the Cities for the weekend. He gave me his beeper and left me on call for our service.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“He "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("what?")]), _vm._v("” John then called over several other senior residents. He introduced me, then told them Art had left me with the beeper for the weekend.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("They all laughed. “Typical Art,” they said. “Heck of a deal!”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("A minute later, just as I found the pretzels, my beeper went off. I was so startled I almost dropped the bowl. The operator instructed me to call the ortho floor at Methodist. Oh, God, I thought, this is it. Someone’s going to tell me I have to rush over to Methodist Hospital and perform some emergency operation I’ve never even heard of.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Heart pounding, I held my Coke over my head and squeezed through the crush of people in John’s kitchen. I found a telephone in the bedroom, closed the door, and dialed the number.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Dr. Collins,” I said to the nurse who answered.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Dr. Collins?” came the puzzled reply. “We were looking for Dr. Hestry.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I’m covering for him.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You are?” she said. “And this is Dr. Collins? I don’t think I know you.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Well, I just started today. I’m Dr. Harding’s junior resident.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Oh. Okay,” she said reasonably, and then went on very businesslike. “I’m Ann Cheevers, the nurse taking care of Mrs. Wiltshire. Can we get her up?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I frantically searched my memory. Mrs. Wiltshire. Mrs. Wiltshire. I vaguely remembered the name. I stalled and finally mumbled, “Mrs. Wiltshire…?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Yes, Mrs. Wiltshire, in 7214. She had a TKA three days ago.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("TKA, I thought in a panic. Oh, yeah, total knee arthroplasty.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Well, at least I knew what it was, but could we get her up? I hadn’t a clue. I didn’t know if “we” always got people up on the third day or if we never did. Mrs. Wiltshire was probably the wife of the president of Switzerland or something. What if I did the wrong thing? I could see the headlines of the Rochester "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Post-Bulletin")]), _vm._v(" the next day:")]), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak",
    staticStyle: {
      "text-indent": "0%"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "paraCenter",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("IDIOT JUNIOR RESIDENT MISTAKENLY LETS"), _c('br'), _vm._v(" WIFE OF SWISS PRESIDENT WALK ON THIRD DAY. LEG FALLS OFF.")])]), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak",
    staticStyle: {
      "text-indent": "0%"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("I’d be finished. My career at Mayo would have lasted one day—although I would have to stay in Rochester for years while the malpractice trial dragged on. “Tell the ladies and gentlemen of the jury one more time, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Doctor")]), _vm._v(", how you crippled this poor mother of ten who had just won the Nobel Peace Prize.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I had been silent for quite a while when the nurse finally said, “Hello? Are you still there?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Uh, yeah. I’m still here.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Well, can we get her up or not?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("There was no point in thinking it over. There was no way I could rationally discover an answer. Instead, I did the smartest thing I could have done: I threw myself on the mercy of the nurse.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Look, Ann,” I said, “I’m new and I honestly don’t know. What do you usually do?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("This was her chance. She probably had been humiliated more than once by some egotistical resident. Now was her chance to get some payback.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I waited. She was silent for a moment and then must have taken pity on me. She let the opportunity to humiliate me pass. It wasn’t the first time a nurse had helped me and it wouldn’t be the last.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“We usually let them up. She’s been doing fine. I think Dr. Hestry just forgot to write the order.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Oh. Okay. Then it’s fine. You can get her up.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Thank you, Doctor.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I let out a long breath. “I owe you one, Ann.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“That’s all right,” she said with a laugh. “So where’s Art?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I wasn’t sure if “covering” for Art meant lying for him, too. “Art? Oh. Well, Art is, uh…”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Yes?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“He…Well, he can’t come to the phone right now.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Yes, of course. I suppose he’s desperately ill. Tell him I hope he feels better soon.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I will.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Tell him a couple aspirin and an ice pack on the forehead tomorrow morning might help.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Well, I’m sure Art would never—”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Good night, Doctor.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I hung up the phone and breathed a sigh of relief. I had passed my first test—barely. I went out to the living room and thanked John for inviting me. Then Patti and I headed home. I wanted to get a good night’s sleep. The next morning I had to make rounds on every one of Dr. Harding’s patients—by myself.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fd4e173a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781429903073_ch01.vue
// module id = 78
// module chunks = 0